import { render } from "./CheckBoxList.vue?vue&type=template&id=04ad2150&scoped=true"
import script from "./CheckBoxList.vue?vue&type=script&lang=js"
export * from "./CheckBoxList.vue?vue&type=script&lang=js"

import "./CheckBoxList.vue?vue&type=style&index=0&id=04ad2150&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1697103798/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04ad2150"]])

export default __exports__